<div class="public-schedule">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="publicForm">
          <form [formGroup]="publicScheduleForm" >
            <div class="button-group">
              <button mat-raised-button color="warn" class="btn-warn" (click)="back()">
                {{'test.editSchedule.btnBack' | translate}}</button>
              <!-- {{isLive}}{{publicScheduleForm.status=='INVALID'? true: false}}{{isCompleted}} -->
              <div class="btn-right">
                <button mat-flat-button color="" (click)="cancelTestSchedule()"
                  [disabled]="isCompleted  || (rolSer.accessData && !rolSer.accessData.deleteAllowed)" class="btn-primary"
                  aria-label="Cancel Schedule">{{'test.editSchedule.btnCancel' | translate}}</button>
                <button mat-raised-button color="" class="btn-primary" [disabled]="publicScheduleForm.status=='INVALID'? true: false
                  || isCompleted || ((chipSelectedExaminee.length === 0 && !isParameterVisible) ? true: false )
                  || isEndTimeValid || isStartTimeValid" (click)="onSubmit(publicScheduleForm)">{{'test.editSchedule.btnSave' | translate}}</button>
              </div>
            </div>
            <div class="form-group ptb-padding">
              <label for="Schedule name">{{'test.editSchedule.public.labelName' | translate}}<span class="red-asterisk">*</span></label>
              <input type="text" autocomplete="off" class="form-control" id="schName" aria-describedby="scheduleName" maxlength="121"
                formControlName="schName" [disabled]="isCompleted">
              <div *ngIf="f.schName.invalid && (f.schName.dirty ||
                f.schName.touched )">
                <div class="alert alert-danger" *ngIf="f.schName.errors?.required">
                  {{'test.editSchedule.public.nameError1' | translate}}</div>
                <div class="alert alert-danger" *ngIf="f.schName.errors?.minlength">
                  {{'test.editSchedule.public.nameError2' | translate}}</div>
                <div class="alert alert-danger" *ngIf="f.schName.errors?.maxlength">
                  {{'test.editSchedule.public.nameError3' | translate}}</div>
              </div>

            </div>
            <div class="form-group">
              <label for="Schedule description">{{'test.editSchedule.public.labelDesc' | translate}}</label>
              <textarea class="form-control" type="text" maxlength="481" id="schDescription" aria-describedby="scheduledescription" value=""
                name="schDescription" formControlName="schDescription"></textarea>
              <div *ngIf="f.schDescription.invalid && (f.schDescription.dirty ||
                f.schDescription.touched )" class="alert alert-danger">
                <!-- <div *ngIf="f.schDescription.errors?.minlength">Minimum 3 characters required</div> -->
                <div *ngIf="f.schDescription.errors?.maxlength">{{'test.editSchedule.public.descError2' | translate}}</div>
              </div>
            </div>
            <div class="form-group details ptb-padding">
              <div class="filter-section title mb-margin">
                <strong>{{'test.editSchedule.public.labelDetail' | translate}}</strong> </div>
                <label>{{'test.createSchedule.public.userParams' | translate}} <span class="red-asterisk">*</span></label>
              <br>
              <div class="">
                <mat-checkbox formControlName="AutoUniqueId" (change)="onSelectAutoGenerateUniqueID($event)">{{'test.createSchedule.public.autoUUID' | translate}}</mat-checkbox>
                <br><br>
              </div>
              <!-- <label for="">Add examinne parameters*</label> -->
              <mat-form-field class="chip-list" *ngIf="!isParameterVisible">
                <!-- <mat-label>{{'test.editSchedule.public.placeholder' | translate}}<span class="red-asterisk">*</span></mat-label> -->
                <mat-chip-list #chipList>
                  <mat-chip *ngFor="let examinee of chipSelectedExaminee" [selectable]=false>
                    {{examinee.fullName}}
                    <!-- <button class="btn-icon">
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </button> -->
                  </mat-chip>
                  <input placeholder="" required #examineeInput [formControl]="examineeControl" [matChipInputFor]="chipList" readonly
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]=true (matChipInputTokenEnd)="addExaminee($event)">
                </mat-chip-list>
              </mat-form-field>
              <div *ngIf="isExamineeExist && !isParameterVisible" class="alert alert-danger">{{'test.editSchedule.public.examineeError1' | translate}}</div>
              <div *ngIf="isWrongExamineeValue || isMultipleSameExamineeValue && !isParameterVisible" class="alert alert-danger">
                {{'test.createSchedule.public.examineeError2' | translate}}
              </div>
              <!-- <div *ngIf="validateParam && !isParameterVisible" class="alert alert-danger">
                {{'test.createSchedule.public.examineeError3' | translate}}
              </div> -->
            </div>

            <div class="row parameters" *ngIf="!isParameterVisible">
              <div class="col-lg-2 param" *ngFor="let param of createParamList">
                <mat-checkbox [checked]="param.checked" (change)="onSelectParam(param.key, $event)">{{param.value}}</mat-checkbox>
              </div>
              <br>
            </div>

            <!-- <div class="row parameters" *ngIf="!isParameterVisible">

              <div class="col-lg-2 param">
                <mat-checkbox formControlName="UniqueId"  (change)="onSelectParam('uuid', $event)">Unique ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox formControlName="email" [checked]="'uuid' === selectedParam" (change)="onSelectParam('email', $event)">Email</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox formControlName="firstName" (change)="onSelectParam('fname', $event)">First name</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox formControlName="lastName" (change)="onSelectParam('lname', $event)">Last name</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox formControlName="phone" (change)="onSelectParam('phone', $event)">Phone</mat-checkbox>
              </div>
            </div>

            <div class="row parameters" *ngIf="!isParameterVisible">
              <div class="col-lg-2 param">
                <mat-checkbox formControlName="enrollmentId" (change)="onSelectParam('enrollmentid', $event)">Enrollment ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox formControlName="assesmentId" (change)="onSelectParam('assessmentid', $event)">Assessment ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox formControlName="classId"  [checked]="'classid' === selectedParam" (change)="onSelectParam('classid', $event)">Class ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox formControlName="UserId" (change)="onSelectParam('userid', $event)">User ID</mat-checkbox>
              </div>
              <div class="col-lg-2 param">
                <mat-checkbox formControlName="AssignmentId" (change)="onSelectParam('assignmentid', $event)">Assignment ID</mat-checkbox>
              </div>
              <br>
            </div> -->

            <div class="form-group date-n-time pb-padding pt-padding">
              <div class="row">
                <div class="col-md-2">
                  <div class="input-class">
                    <label for="">{{'test.editSchedule.public.dateAndTime.startDate' | translate}}<span class="red-asterisk">*</span></label>
                    <mat-form-field class="example-full-width" appearance="fill">
                      <mat-label></mat-label>
                      <input matInput [matDatepicker]="picker" [min]="minDate" formControlName="startDate" [disabled]="isLive" readonly/>
                      <!-- <input matInput [matDatepicker]="picker" formControlName="startDate"> -->
                      <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>

                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                    <div *ngIf="f.startDate.invalid && (f.startDate.dirty ||
                      f.startDate.touched )" class="alert alert-danger"> Start Date is invalid
                      <div *ngIf="f.startDate.errors?.required">Start Date is
                        required
                      </div>
                    </div>

                  </div>
                </div>
                <div class="col-md-2 date-class">
                  <div class="input-time">
                    <label class="timepicker" for="">{{'test.editSchedule.public.dateAndTime.startTime' | translate}}<span class="red-asterisk">*</span></label>
                    <!-- <ngx-timepicker-field [format]="24" aria-disabled="true" [defaultTime]="'00:00'" formControlName="startTime">
                    </ngx-timepicker-field> -->
                    <ngx-timepicker-field [format]="24" aria-disabled="true" [defaultTime]="'00:00'"
                      formControlName="startTime" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="okBtn">
                    </ngx-timepicker-field>
                    <ng-template #cancelBtn>
                      <button class="clock">
                        {{'test.editSchedule.public.dateAndTime.btnCancel' | translate}} </button>
                    </ng-template>
                    <ng-template #okBtn>
                      <button class="clock">
                        {{'test.editSchedule.public.dateAndTime.btnOk' | translate}}</button>
                    </ng-template>


                    <div *ngIf="isStartTimeValid" class="alert alert-danger">
                      {{'test.editSchedule.public.dateAndTime.startTimeError1' | translate}}
                    </div>
                    <!-- <div *ngIf="f.startTime.invalid && (f.startTime.dirty || f.startTime.touched ) "
                                            class="alert alert-danger">
                                            <div *ngIf="f.startTime.errors?.required">Start Time is required</div>
                                        </div> -->
                  </div>
                </div>

                <div class="col-md-2 date-class">
                  <div class="input-class">
                    <label for="">{{'test.editSchedule.public.dateAndTime.endDate' | translate}}<span class="red-asterisk">*</span></label>
                    <mat-form-field class="example-full-width" appearance="fill">
                      <!-- <mat-label>End date</mat-label> -->
                      <input matInput [matDatepicker]="picker1" [min]="minDate1" formControlName="endDate" readonly/>
                      <!-- <input matInput [matDatepicker]="picker1" formControlName="endDate"> -->
                      <mat-datepicker-toggle matSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <div *ngIf="f.endDate.invalid && (f.endDate.dirty ||
                      f.endDate.touched )" class="alert alert-danger"> End Date is invalid
                      <div *ngIf="f.endDate.errors?.required">End Date is
                        required</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 date-class">
                  <div class="input-time">
                    <label class="timepicker" for="">{{'test.editSchedule.public.dateAndTime.endTime' | translate}}<span class="red-asterisk">*</span></label>
                    <!-- <ngx-timepicker-field [format]="24" [defaultTime]="'00:00'" formControlName="endTime">
                    </ngx-timepicker-field> -->
                    <ngx-timepicker-field [format]="24" aria-disabled="true" [defaultTime]="'00:00'"
                      formControlName="endTime" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="okBtn">
                    </ngx-timepicker-field>
                    <ng-template #cancelBtn>
                      <button class="clock">
                        {{'test.editSchedule.public.dateAndTime.btnCancel' | translate}} </button>
                    </ng-template>
                    <ng-template #okBtn>
                      <button class="clock">
                        {{'test.editSchedule.public.dateAndTime.btnOk' | translate}}</button>
                    </ng-template>


                    <div *ngIf="isEndTimeValid" class="alert alert-danger">
                      {{'test.editSchedule.public.dateAndTime.endTimeError1' | translate}}
                    </div>
                    <!-- <div *ngIf="f.endTime.invalid && (f.endTime.dirty || f.endTime.touched )"
                                            class="alert alert-danger">
                                            <div *ngIf="f.endTime.errors?.required">End Time is required</div>
                                        </div> -->
                  </div>
                </div>
                <div class="col-md-3 date-class">
                  <div class="input-class">
                    <label class="timepicker" for="">{{'test.editSchedule.public.dateAndTime.timezone' | translate}}<span class="red-asterisk">*</span></label>
                    <mat-select class="form-control timeZ" name="timezone" [disabled]="isCompleted" formControlName="timeZone" [value]="zone">
                      <mat-select-filter [array]="searchOptions" [displayMember]="'name'" (filteredReturn)="filteredList=$event" placeholder="{{'test.editSchedule.public.dateAndTime.inputSearch' | translate}}"></mat-select-filter>
                      <mat-option value="">
                        {{'test.editSchedule.public.dateAndTime.defaultTimezone' | translate}}</mat-option>
                      <mat-option *ngFor="let option of filteredList; let i=
                        index" [value]="option.name">
                        {{option?.name}}
                      </mat-option>
                    </mat-select>
                    <div *ngIf="f.timeZone.invalid && (f.timeZone.dirty ||
                      f.timeZone.touched )" class="alert alert-danger">
                      <div *ngIf="f.timeZone.errors?.required">{{'test.editSchedule.public.dateAndTime.timezoneError1' | translate}}</div>

                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="form-group settings pb-padding">
              <div class="filter-section title"> <strong>{{'test.editSchedule.public.labelSetting' | translate}}</strong>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.editSchedule.public.inputSettings.testScore' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput style-non" readonly formControlName="testTotalScore"><span>{{'test.editSchedule.public.inputSettings.labelmarks' | translate}}</span>
                  <div *ngIf="f.testTotalScore.invalid &&
                    (f.testTotalScore.dirty || f.testTotalScore.touched )" class="alert alert-danger">
                    <div *ngIf="f.testTotalScore.errors?.required">{{'test.editSchedule.public.inputSettings.testScoreError1' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.labelQuestMandotry' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="maxAttempts">
                    <mat-slide-toggle formControlName="iallquestionsmandatory">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.editSchedule.public.inputSettings.testDuration' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput" formControlName="testDuration" min="0" max="9999"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"><span>{{'test.editSchedule.public.inputSettings.labelmin' | translate}}</span>
                  <div *ngIf="f.testDuration.invalid && (f.testDuration.dirty ||
                    f.testDuration.touched )" class="alert alert-danger">
                    <div *ngIf="f.testDuration.errors?.required">
                      {{'test.editSchedule.public.inputSettings.testDurationError1' | translate}}
                    </div>
                    <div *ngIf="f.testDuration.errors?.pattern">
                      {{'test.editSchedule.public.inputSettings.testDurationError2' | translate}}
                    </div>
                  </div>

                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.showToolSetting' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="maxAttempts">
                    <mat-slide-toggle formControlName="showTools">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="col-md-2"></div>

                <!-- <div class="col-md-8">
                                    <div class="switch-op">
                                        <label for="">Examinee rejoin the test</label>
                                        <mat-slide-toggle formControlName="ExamineeRejoinTest">
                                        </mat-slide-toggle>

                                    </div>
                                </div> -->
              </div>

              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.editSchedule.public.inputSettings.testPass' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput" formControlName="testPassingScore" min="0" (keyup)="testScoreChange()"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                    max="9999"><span>{{'test.editSchedule.public.inputSettings.labelmarks' | translate}}</span>
                    <div *ngIf="f.testPassingScore.invalid && (f.testPassingScore.dirty || f.testPassingScore.touched )" class="alert alert-danger">
                      <div *ngIf="f.testPassingScore.errors?.required">
                        {{'test.createSchedule.public.inputSettings.testPassError1' | translate}}
                      </div>
                      <!-- <div *ngIf="f.penaltyPoints.errors?.pattern">
                        {{'test.createSchedule.public.inputSettings.testDurationError2' | translate}}
                      </div> -->
                    </div>
                  <!-- <div *ngIf="f.testPassingScore.invalid &&
                    (f.testPassingScore.dirty || f.testPassingScore.touched )" class="alert alert-danger">
                    <div *ngIf="f.testPassingScore.errors?.required">{{'test.editSchedule.public.inputSettings.testPassError1' | translate}}</div>
                    <div *ngIf="f.testPassingScore.errors?.pattern">{{'test.editSchedule.public.inputSettings.testPassError2' | translate}}</div>
                  </div>
                  <div *ngIf="setTestScoremsg" class="alert alert-danger">
                    <div>{{'test.editSchedule.public.inputSettings.testPassError3' | translate}}</div>
                  </div> -->

                </div>

                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.showItemListSetting' | translate}}</label>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="maxAttempts">
                    <mat-slide-toggle formControlName="showItemList">
                    </mat-slide-toggle>
                  </div>
                </div>
                <div class="col-md-2"></div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.editSchedule.public.inputSettings.testPenalty' | translate}}<span class="red-asterisk">*</span></label>
                  </div>
                </div>
                <div class="col-md-2">
                  <input type="number" class="settingInput" formControlName="penaltyPoints" min="0" (keyup)="checkTestValue()"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" onkeypress="if(this.value.length == 4 ) return false;"
                    max="9999"><span>{{'test.editSchedule.public.inputSettings.labelmarks' | translate}}</span>
                    <div *ngIf="f.penaltyPoints.invalid && (f.penaltyPoints.dirty || f.penaltyPoints.touched )" class="alert alert-danger">
                      <div *ngIf="f.penaltyPoints.errors?.required">
                        {{'test.createSchedule.public.inputSettings.penaltyError1' | translate}}
                      </div>
                      <!-- <div *ngIf="f.penaltyPoints.errors?.pattern">
                        {{'test.createSchedule.public.inputSettings.testDurationError2' | translate}}
                      </div> -->
                    </div>
                  <!-- <div *ngIf="f.penaltyPoints.invalid && (f.penaltyPoints.dirty
                    || f.penaltyPoints.touched )" class="alert alert-danger">
                    <div *ngIf="f.penaltyPoints.errors?.required">{{'test.editSchedule.public.inputSettings.penaltyError1' | translate}}</div>
                    <div *ngIf="publicScheduleForm.controls.penaltyPoints.value<0">{{'test.editSchedule.public.inputSettings.penaltyError2' | translate}}</div>
                  </div>
                  <div *ngIf="setPenaltymsg" class="alert alert-danger">
                    <div>{{'test.editSchedule.public.inputSettings.penaltyError3' | translate}}</div>
                  </div> -->

                </div>
                <div class="col-md-3"></div>
                <div class="col-md-2">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.maxNumberofAttempts' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1">
                  <div class="maxAttempts">
                    <select class="form-control" [(ngModel)]="maxAttempts" (change)="onSelectMaxAttempts($event)" formControlName="MaxAttempts">
                      <option value="{{i}}" *ngFor='let in of counter(21) ;let i = index'>{{i}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-2"></div>
              </div>

              <div class="row">
                <div class="col-md-7"></div>
                <div class="col-md-2" *ngIf="isAllowAttempts">
                  <div class="setting-label">
                    <label for="">{{'test.createSchedule.public.inputSettings.allowAttemptsAfter' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="isAllowAttempts">
                  <div class="allow-Attempts">
                    <select class="form-control" [(ngModel)]="weeks" formControlName="Weeks">
                      <option value="{{i}}" *ngFor='let in of counter(21) ;let i = index'>{{i}}</option>
                    </select>
                    <label class="attemptsLable">{{'test.createSchedule.private.inputSettings.weeks' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="isAllowAttempts">
                  <div class="allow-Attempts">
                    <select class="form-control" [(ngModel)]="days" formControlName="days">
                      <option value="{{i}}" *ngFor='let in of counter(31) ;let i = index'>{{i}}</option>
                    </select>
                    <label class="attemptsLable">{{'test.createSchedule.private.inputSettings.days' | translate}}</label>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="isAllowAttempts">
                  <div class="allow-Attempts">
                    <select class="form-control" [(ngModel)]="hours" formControlName="hours">
                      <option value="{{i}}" *ngFor='let in of counter(24) ;let i = index'>{{i}}</option>
                    </select>
                    <label class="attemptsLable">{{'test.createSchedule.private.inputSettings.hours' | translate}}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="messages pb-padding">
              <div class="title" id="mrg-bottom"> <strong>{{'test.editSchedule.public.labelMsg' | translate}}</strong>
              </div>
              <div class="filter-section"> <label>{{'test.editSchedule.public.labelPreTest' | translate}}<span class="red-asterisk">*</span></label></div>
              <div class="row">
                <div class="col-md-12 editor-cls">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                  </ngx-editor-menu>
                  <ngx-editor name='optionbox' [placeholder]="'test.editSchedule.public.placeholderEnter' | translate" class="form-control textarea" [editor]="editor"
                    formControlName="preMessageText">
                  </ngx-editor>
                  <div *ngIf="f.preMessageText.invalid &&
                    (f.preMessageText.dirty || f.preMessageText.touched )" class="alert alert-danger">
                    <div *ngIf="f.preMessageText?.errors?.minlength">{{'test.editSchedule.public.preTestError1' | translate}}</div>
                    <!-- <div *ngIf="f.preMessageText?.errors?.minlength">Minimum 2 characters
                                            required</div> -->
                    <div *ngIf="f.preMessageText?.errors?.maxlength">{{'test.editSchedule.public.preTestError2' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="filter-section post-wrapper"><label>{{'test.editSchedule.public.labelPostTest' | translate}}<span class="red-asterisk">*</span> </label></div>
              <div class="row" class="'mrg-top-msg">
                <div class=" editor-cls">
                  <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar">
                  </ngx-editor-menu>
                  <ngx-editor name='optionbox' [placeholder]="'test.editSchedule.public.placeholderEnter' | translate" class="form-control" [editor]="editor1" maxLength="1001"
                    formControlName="postMessageText">
                  </ngx-editor>
                  <div *ngIf="f.postMessageText.invalid &&
                    (f.postMessageText.dirty || f.postMessageText.touched )" class="alert alert-danger">
                    <div *ngIf="f.postMessageText?.errors?.minlength">{{'test.editSchedule.public.postTestError1' | translate}}</div>
                    <!-- <div *ngIf="f.postMessageText?.errors?.minlength">Minimum 2 characters
                                            required</div> -->
                    <div *ngIf="f.postMessageText?.errors?.maxlength">{{'test.editSchedule.public.postTestError2' | translate}}</div>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>
